import React, { useEffect, useState, useCallback } from "react";
import "./NetflixTitle.css";
import netflixSound from "./netflix-sound.mp3";
import { useNavigate } from "react-router-dom";

const NetflixTitle = () => {
  const [started, setStarted] = useState(false);
  const [phase, setPhase] = useState<'big-y' | 'shrink-move' | 'join' | 'zoom-out'>('big-y');
  const [showCinematicBars, setShowCinematicBars] = useState(false);
  const navigate = useNavigate();

  const startIntro = useCallback(() => {
    if (started) return;
    setStarted(true);

    // Play Netflix "tudum" sound immediately on user interaction
    const audio = new Audio(netflixSound);
    audio.volume = 1.0;
    audio.play().catch((error) => console.error("Audio play error:", error));

    // Show cinematic bars
    setTimeout(() => setShowCinematicBars(true), 100);

    // Phase 2: Y shrinks
    setTimeout(() => setPhase('shrink-move'), 2000);

    // Phase 3: UG PATIL joins
    setTimeout(() => setPhase('join'), 2800);

    // Phase 4: Zoom out
    setTimeout(() => setPhase('zoom-out'), 5000);

    // Navigate to browse
    setTimeout(() => navigate("/browse"), 6500);
  }, [started, navigate]);

  // Try auto-start (works if user has interacted with site before)
  useEffect(() => {
    const audio = new Audio(netflixSound);
    audio.volume = 1.0;
    
    const playPromise = audio.play();
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Audio started successfully - run the animation
          setStarted(true);
          setTimeout(() => setShowCinematicBars(true), 100);
          setTimeout(() => setPhase('shrink-move'), 2000);
          setTimeout(() => setPhase('join'), 2800);
          setTimeout(() => setPhase('zoom-out'), 5000);
          setTimeout(() => navigate("/browse"), 6500);
        })
        .catch(() => {
          // Autoplay blocked - wait for user click
          console.log("Autoplay blocked - click to start");
        });
    }
  }, [navigate]);

  const handleSkip = () => {
    navigate("/browse");
  };

  return (
    <div className="netflix-container" onClick={startIntro}>
      {/* Vignette overlay */}
      <div className="vignette" />

      {/* Creative Cinema Entrance */}
      {!started && (
        <div className="cinema-entrance">
          {/* Spotlight beams */}
          <div className="spotlight spotlight-1" />
          <div className="spotlight spotlight-2" />
          
          {/* Main card */}
          <div className="entrance-card">
            {/* Animated border */}
            <div className="card-border" />
            
            {/* Y letter preview */}
            <div className="preview-letter">Y</div>
            
            {/* Divider line */}
            <div className="card-divider" />
            
            {/* Enter text */}
            <div className="enter-section">
              <span className="enter-label">Click to Enter</span>
              <span className="portfolio-name">YUG'S PORTFOLIO</span>
            </div>
            
            {/* Animated arrow */}
            <div className="enter-arrow">
              <span>▶</span>
            </div>
          </div>
          
          {/* Bottom hint */}
          <div className="bottom-hint">
            <div className="hint-line" />
            <span>PRESS ANYWHERE</span>
            <div className="hint-line" />
          </div>
        </div>
      )}

      {/* Cinematic letterbox bars */}
      <div className={`cinematic-bar top ${showCinematicBars ? 'show' : ''}`} />
      <div className={`cinematic-bar bottom ${showCinematicBars ? 'show' : ''}`} />

      {/* Name Animation Container */}
      {started && (
        <div className={`name-wrapper phase-${phase}`}>
          <div className="name-glow" />
          <span className="letter-y">Y</span>
          <span className="rest-of-name">UG PATIL</span>
        </div>
      )}

      {/* Skip button */}
      {started && (
        <button className="skip-button" onClick={handleSkip}>
          Skip Intro
        </button>
      )}
    </div>
  );
};

export default NetflixTitle;
